
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M21 12L7 21L7 3L21 12Z" fill="currentColor"></path></svg>';export default svg;
    